import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { getDeviceSpecV2 } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { createSelector } from '@reduxjs/toolkit';
import { selectDevicesFields } from 'entities/device/lib';
import { User } from 'z3k-config';
function filterDeviceWithoutPhones(dev) {
    if (!LegacyDevice.has_capability(dev.capabilities, Capability.has_gsm)) {
        return false;
    }
    const device_spec = getDeviceSpecV2(dev.device_type?.code, dev.hardware_type?.code);
    if (device_spec != null && !device_spec.network.has_gsm) {
        return false;
    }
    if (dev.rejected_trust_phones) {
        return false;
    }
    //Как звонить без симки?
    if (dev.sim_in_device == null) {
        return false;
    }
    if (device_spec == null) {
        return (dev.trusted_phones ?? '').split(',').length == 0;
    }
    if (dev.z3k_config == null) {
        return false;
    }
    return !User.get.some(dev.z3k_config, ({ phone }) => phone != null);
}
export const trustPhoneDevices = createSelector(selectDevicesFields([
    'id',
    'name',
    'individual_device_name',
    'trusted_phones',
    'tel_password',
    'sim_in_device',
    'device_type',
    'hardware_type',
    'z3k_config',
    'capabilities',
    'rejected_trust_phones',
]), (devs) => devs.filter(filterDeviceWithoutPhones).map((dev) => ({
    ...dev,
    name: LegacyDevice.display_name(dev),
})));
export { validatePhone } from 'entities/device.trust-phones/model/validation';
export { validateVoiceMenu } from 'entities/device.trust-phones/model/validation';
